/* eslint-disable */

// @ts-nocheck
export default function WireframeCssAssetMobile() {
    return (
        <>
            <style
                jsx
                global
            >{`
                /* MAIN DECLARATIONS */
                /* html { height:100%; } */
                /* body { background-color:#f4f4f4; margin:0; padding:0; font-family:Arial, Helvetica, sans-serif; font-size:12px; line-height:16px; color:#333333; -webkit-text-size-adjust:100%; height:100%; width:100%; overflow-x:hidden; position:relative; } */
                /* a { text-decoration: none; color: #0563C1; cursor:pointer; } */
                /* img { border: 0; } */
                /* form, fieldset { border: 0; margin: 0; padding: 0; } */
                /* input, select, textarea { font-size: 12px; color:#333333; } */
                /* input:focus, select:focus, textarea:focus, button:focus { outline: none; } */

                /* CLEAR ELEMENTS */
                /* .clear { clear: both; display: block; overflow: hidden; visibility: hidden; width: 0; height: 0; } */
                .clearfix:before,
                .clearfix:after {
                    content: '\\0020';
                    display: block;
                    overflow: hidden;
                    visibility: hidden;
                    width: 0;
                    height: 0;
                }
                .clearfix:after {
                    clear: both;
                }
                /* .clearfix { zoom: 1; } */

                /* TRACKING */
                /* .c24-tracking { position: absolute; top: -10px; left: -10px; } */
                /* .c24-gt { position:absolute; top:-10px; } */
                iframe[name='google_conversion_frame'] {
                    height: 0 !important;
                    width: 0 !important;
                    line-height: 0 !important;
                    font-size: 0 !important;
                    margin-top: -13px;
                    float: left;
                }
                /* PAGE */
                .c24m-page {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -webkit-flex-direction: column;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    height: 100%;
                    width: 100%;
                    z-index: 10;
                    transition: left 0.2s;
                    -webkit-transition: left 0.2s;
                    -moz-transition: left 0.2s;
                    position: relative;
                    top: 0;
                    left: 0;
                }
                .c24m-page.c24m-nav-animate {
                    left: 100%;
                }
                .c24m-page-content {
                    -webkit-flex: 1 0 auto;
                    -ms-flex: 1 0 auto;
                    flex: 1 0 auto;
                    min-width: 0;
                }
                @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                    /* IE Flexbox hack */
                    .c24m-page-content {
                        display: block;
                    }
                }
                .c24m-container {
                    background: #fff;
                    border: 1px solid #dcdcdc;
                    padding: 16px 10px;
                }
                .c24-container-content {
                    margin-bottom: 5px;
                }
                /* .c24-container-nospacing {
    margin-bottom:0;
} */
                /* .c24-container-flex {
    width:100%;
    margin:0;
} */
                #c24m-page-blocking-layer,
                #c24m-page-strict-blocking-layer {
                    background: rgba(0, 0, 0, 0.6);
                    position: fixed;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    left: 0;
                    z-index: 111;
                    cursor: pointer;
                    display: none;
                }
                #c24m-page-strict-blocking-layer {
                    cursor: inherit;
                }

                /* CONTENT ELEMENTS Buttons */
                a.c24m-button,
                input.c24m-button,
                a.c24m-button:visited,
                input.c24m-button:visited,
                .c24m-cookie-button,
                .c24m-cookie-consent-button {
                    text-decoration: none;
                    font-family: Arial, Helvetica, sans-serif;
                    font-weight: normal;
                    cursor: pointer;
                    border: 0;
                    background-color: #0563c1;
                    -moz-border-radius: 3px;
                    -webkit-border-radius: 3px;
                    border-radius: 3px;
                    vertical-align: middle;
                    color: #ffffff;
                    font-size: 16px;
                    line-height: 20px;
                    height: auto;
                    padding: 15px 0;
                    display: block;
                    text-align: center;
                    width: 100%;
                    -webkit-appearance: none;
                }
                a.c24m-button:active,
                input.c24m-button:active,
                a.c24m-button:hover,
                input.c24m-button:hover,
                .c24m-cookie-button:hover,
                a.c24m-cookie-consent-button:not(.c24m-cookie-consent-button-secondary):hover {
                    background-color: #064e9c;
                }

                /* CONTENT ELEMENTS forms and form-elements */
                /* input, select {
    border-radius:0;
    -webkit-appearance: none;
} */
                .c24m-input {
                    width: 100%;
                    box-sizing: border-box;
                    height: 34px;
                    font-size: 14px;
                    color: #333333;
                    padding: 0 10px;
                    border: 1px solid #dcdcdc;
                    background: #ffffff;
                    -webkit-appearance: none;
                } /* HEADER */
                /* header { -webkit-flex:none; -ms-flex:none; flex:none; } */
                #c24m-header {
                    -webkit-flex: none;
                    -ms-flex: none;
                    flex: none;
                    display: block;
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    background: #022d94;
                }
                .c24m-header-content {
                    padding: 0 10px;
                    position: relative;
                    background: #022d94;
                }
                #c24m-header-top {
                    height: 42px;
                }
                .c24m-header-top-icons-left {
                    display: inline-block;
                    float: left;
                    padding-left: 12px;
                }
                .c24m-header-top-icons-right {
                    display: inline-block;
                    float: right;
                    padding-right: 12px;
                }
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) .c24m-header-icon {
                    float: unset;
                }
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) #c24m-header-top {
                    display: flex;
                }
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) .c24m-header-top-icons-left,
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) .c24m-header-top-icons-right {
                    display: flex;
                    flex: none;
                }
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) .c24m-header-top-icons-right {
                    flex-direction: row-reverse;
                }
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) .c24m-header-top-icons-left {
                    justify-content: start;
                }
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) .c24m-header-top-icons-right {
                    justify-content: end;
                }
                #c24m-header.c24-product-title-visible.c24-header-column-1:not(.c24-product-title-invisible)
                    .c24m-header-top-icons-left,
                #c24m-header.c24-product-title-visible.c24-header-column-1:not(.c24-product-title-invisible)
                    .c24m-header-top-icons-right {
                    width: 42px;
                }
                #c24m-header.c24-product-title-visible.c24-header-column-2:not(.c24-product-title-invisible)
                    .c24m-header-top-icons-left,
                #c24m-header.c24-product-title-visible.c24-header-column-2:not(.c24-product-title-invisible)
                    .c24m-header-top-icons-right {
                    width: 94px;
                }
                #c24m-header.c24-product-title-visible.c24-header-column-3:not(.c24-product-title-invisible)
                    .c24m-header-top-icons-left,
                #c24m-header.c24-product-title-visible.c24-header-column-3:not(.c24-product-title-invisible)
                    .c24m-header-top-icons-right {
                    width: 130px;
                }

                /* HEADER product name */
                #c24m-product-name {
                    display: none;
                }
                #c24m-header.c24-product-title-visible #c24m-product-name {
                    display: block;
                    height: 20px;
                    margin: 11px auto;
                    color: #fff;
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    line-height: 20px;
                    white-space: nowrap;
                }
                #c24m-header.c24-product-title-visible.c24-product-title-invisible #c24m-product-name {
                    display: none;
                }

                /* HEADER Logo */
                #c24m-logo {
                    display: block;
                    width: 70px;
                    height: 16px;
                    margin: 0 auto;
                    cursor: pointer;
                    position: absolute;
                    left: calc(50% - 35px);
                    top: 13px;
                }
                #c24m-header.c24-product-title-visible:not(.c24-product-title-invisible) #c24m-logo {
                    display: none;
                }
                #c24m-logo,
                .c24m-cc-logo,
                .c24-uli-loginlayer-header-logo {
                    background-image: url('data:image/svg+xml;base64,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');
                    background-repeat: no-repeat;
                }

                /* HEADER Back */
                .c24m-header-back-wrapper {
                    display: none;
                    height: 40px;
                    width: 27px;
                    padding: 11px 7px 8px;
                    float: left;
                    cursor: pointer;
                    box-sizing: border-box;
                }
                .c24m-header-back {
                    display: block;
                    height: 22px;
                    width: 11px;
                    box-sizing: border-box;
                }
                .c24m-header-back-option .c24m-header-back-wrapper {
                    display: block;
                }
                #c24m-header-back svg {
                    position: relative;
                }

                /* HEADER Product */
                /* #c24m-product {
    position:absolute; top:0; left:98px;
    width:162px;
    line-height:40px;
    font-size:16px;
    color:#FFFFFF;
    white-space: nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
}
@media screen and (max-width: 370px) {
    #c24m-product { width:160px; }
}
@media screen and (max-width: 340px) {
    #c24m-product { width:140px; }
}
@media screen and (max-width: 328px) {
    #c24m-product { width:126px; }
} */ /* FOOTER */
                .c24m-footer {
                    -webkit-flex: none;
                    -ms-flex: none;
                    flex: none;
                    display: block;
                    width: 100%;
                    border-top: 1px solid #dcdcdc;
                    background-color: #ffffff;
                    color: #333333;
                }
                .c24m-footer.c24m-footer-gray {
                    background-color: #f4f4f4;
                }

                .c24m-footer-content {
                    padding: 10px;
                    text-align: center;
                    font-size: 12px;
                    line-height: 16px;
                }
                body:not(.c24-app-context).c24-tap-bar-visible .c24m-footer-content {
                    margin-bottom: calc(70px + env(safe-area-inset-bottom, 0px));
                }
                .c24m-footer-list {
                    padding: 10px 0 0;
                    display: inline-block;
                    margin: 0 auto;
                }
                .c24m-footer-list li {
                    display: inline-block;
                    padding-bottom: 5px;
                }
                .c24m-footer-content a,
                .c24m-footer a {
                    color: #333333;
                }
                .c24m-footer-content a:hover,
                .c24m-footer a:hover {
                    text-decoration: none;
                }
                .c24m-footer-content p {
                    margin: 0;
                    padding: 0;
                }
                .c24m-footer-content .c24m-desktop-link {
                    padding: 5px 0;
                    display: block;
                    color: #0563c1;
                } /* HEADER Contact */
                .c24m-contact-wrapper {
                    width: 40px;
                    height: 40px;
                    padding: 9px 8px;
                    box-sizing: border-box;
                    float: right;
                }
                .c24m-contact-wrapper .c24m-contact-icon {
                    height: 22px;
                    width: 25px;
                    cursor: pointer;
                    display: block;
                    box-sizing: border-box;
                    position: relative;
                    background-image: url('data:image/svg+xml;base64,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');
                    background-size: contain;
                    background-repeat: no-repeat;
                }
                .c24m-contact-wrapper .c24m-contact-icon.open {
                    z-index: 112;
                }
                .c24m-contact-layer {
                    display: none;
                    position: absolute;
                    top: 40px;
                    right: 10px;
                    border: 1px solid #dcdcdc;
                    background: #ffffff;
                    width: calc(100% - 22px);
                    width: -webkit-calc(100% - 22px);
                    z-index: 120;
                }
                .c24m-contact-layer-corner {
                    content: '';
                    width: 0;
                    height: 0;
                    pointer-events: none;
                    position: absolute;
                    top: -7px;
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    border-bottom: 10px solid #ffffff;
                }

                /* .c24-contact-layer-home .c24m-contact-layer-corner {
    border-bottom: 10px solid #ffffff;
} */

                .c24m-contact-layer-close {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    right: 5px;
                    top: 0;
                    cursor: pointer;
                }
                .c24m-contact-layer-close > svg {
                    width: 14px;
                    height: 14px;
                    float: right;
                    padding-top: 10px;
                    padding-right: 5px;
                    box-sizing: content-box;
                }
                .c24m-contact-layer-content {
                    padding: 0 15px 15px;
                    text-align: center;
                }

                /* .c24-contact-layer-home .c24m-contact-layer-content {
    padding: 0 15px 10px 15px;
} */

                .c24m-contact-slogan {
                    display: table;
                    width: 100%;
                    box-sizing: border-box;
                    margin: 0 0 20px 0;
                    padding: 15px 25px 0;
                    text-align: center;
                    color: #333333;
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: bold;
                }

                /* .c24-contact-layer-home .c24m-contact-slogan-evo {
    background: #ffffff;
    text-align: left;
    min-height: initial;
    padding: 10px 0 0;
} */

                /* .c24-contact-layer-home .c24m-contact-slogan-evo span {
    padding: 0 15px;
} */

                /* .c24m-contact-text, .c24m-contact-text-bottom { color:#333333; font-size:15px; line-height:18px; text-align:center; } */
                /* .c24m-contact-text-evo, .c24m-contact-text-bottom-evo { text-align:left; } */
                /* .c24m-contact-text span { display:block; font-size:18px; line-height:18px; font-weight:bold; color:#0563C1; } */

                /* .c24m-contact-text-bottom {
    margin-top: 10px;
    line-height: 18px;
    font-size: 14px;
    color: #333333;
} */

                /* .c24-contact-layer-home .c24m-contact-text-bottom {
    margin-top: 5px;
} */

                /* .c24m-contact-button { font-size:15px; margin:22px 0 9px; } */
                /* .c24m-contact-layer-content .c24m-hotline {
    padding: 0 0 20px;
    font-size:15px;
    line-height:15px;
    border-bottom: 1px solid #cdcdcd;
    margin-top:5px;
} */
                /* .c24m-contact-layer-content .c24m-email {
    padding: 20px 0 0;
    font-size:15px;
    line-height:15px;
    margin-bottom:5px;
} */
                /* .c24m-contact-layer-content .c24m-hotline a, .c24m-contact-layer-content .c24m-email a {
    display:block;
    font-size:20px;
    line-height:20px;
    font-weight:bold;
    color:#0563C1;
    margin-bottom:8px;
} */
                .c24m-contact-layer.c24m-contact-bottom {
                    top: 1500px;
                    width: calc(100% - 22px);
                }
                .c24m-contact-layer.c24m-contact-bottom .c24m-contact-layer-corner {
                    display: none;
                }
                @media only screen and (min-width: 480px) {
                    .c24m-contact-layer {
                        width: 370px;
                    }
                }
                /* .c24m-contact-wrapper .c24-phone-list {
    font-family: Arial, Helvetica, sans-serif;
    margin-top:-11px;
}

.c24m-contact-wrapper .c24-phone-list ul {
    margin: -5px 0 0;
    padding: 0;
}

.c24m-contact-wrapper .c24-phone-list ul li {
    display: block;
    margin-bottom: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #cdcdcd;
}
.c24m-contact-wrapper .c24-phone-list ul li.c24-space {
    border: none;
    padding: 0;
    margin-bottom: 15px;
}
.c24m-contact-wrapper .c24-phone-list ul li.c24-space .c24-product-headline {
    padding-top: 11px;
}

.c24-contact-layer-home .c24-phone-list ul li.c24-space .c24-product-headline {
    padding-top: 18px;
}

.c24m-contact-wrapper .c24-phone-list ul li:last-child {
    border-bottom: 0;
}

.c24m-contact-wrapper .c24-phone-list ul li a {
    color: #0563C1;
    font-size: 16px;
    text-align: right;
    display: block;
    font-weight: bold;
}

.c24m-contact-wrapper .c24-product-headline {
    font-size: 14px;
    font-weight: bold;
    line-height: 18px;
    color: #333333;
    display: block;
    text-align: left;
}

.c24m-contact-wrapper .c24-product-layer {
    width: 52%;
    float: left;
}

.c24m-contact-wrapper .c24-product-layer p {
    margin: 0;
    font-size: 12px;
    text-align: left;
    color: #999999;
}

.c24m-contact-wrapper .c24-time-layer {
    width: 48%;
    float: right;
    padding-top: 12px;
    color: #0563C1;
    font-size: 16px;
    text-align: right;
    display: block;
}

.c24-contact-layer-home .c24-phone-list ul li.c24-space .c24-time-layer {
    padding-top: 20px;
} */ /* Cookie Consent Screen */
                .c24m-cookie-consent-notice a,
                .c24m-cookie-consent-screen a,
                .c24m-cookie-consent-notice div,
                .c24m-cookie-consent-screen div {
                    /* Fix blue highlight color on Chrome for Android */
                    -webkit-tap-highlight-color: transparent;
                    -webkit-touch-callout: none;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }

                .c24m-cookie-consent-wrapper .c24m-cc-logo {
                    display: block;
                    width: 134px;
                    height: 34px;
                    float: left;
                    cursor: pointer;
                }

                .c24m-cookie-consent-notice a {
                    color: #ffffff;
                    text-decoration: underline;
                }

                .c24m-cookie-consent-wrapper {
                    width: 100%;
                    height: 100%;
                    display: none;
                    justify-content: center;
                    align-items: center;
                    position: fixed;
                    z-index: 112;
                    overflow-y: scroll;
                    line-height: 16px;
                }

                .c24m-cookie-consent-notice,
                .c24m-cookie-consent-screen {
                    background-color: rgba(4, 20, 60, 0.8);
                    border-radius: 5px;
                    padding: 30px 15px 25px;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    color: #ffffff;
                    width: calc(100% - 20px);
                    display: flex;
                    flex-flow: column;
                    max-width: 500px;
                    max-height: calc(100% - 20px);
                    z-index: 112;
                    position: relative;
                }

                .c24m-cookie-consent-notice:before,
                .c24m-cookie-consent-screen:before {
                    background-image: url('data:image/svg+xml;base64,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');
                    background-size: 100%;
                    background-repeat: no-repeat;
                    width: 60px;
                    height: 61px;
                    position: absolute;
                    top: -43px;
                    left: calc(50% - 30px);
                    content: ' ';
                }

                .c24m-cookie-consent-notice-cnt .c24m-cookie-consent-notice-title,
                .c24m-cookie-consent-screen-cnt .c24m-cookie-consent-screen-title {
                    margin-top: 0;
                    margin-bottom: 10px;
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 24px;
                }
                @media screen and (max-height: 500px) {
                    .c24m-cookie-consent-notice-cnt .c24m-cookie-consent-notice-title,
                    .c24m-cookie-consent-screen-cnt .c24m-cookie-consent-screen-title {
                        font-size: 17px;
                        line-height: 20px;
                    }
                }
                @media screen and (max-height: 350px) {
                    .c24m-cookie-consent-notice-cnt .c24m-cookie-consent-notice-title,
                    .c24m-cookie-consent-screen-cnt .c24m-cookie-consent-screen-title {
                        font-size: 15px;
                        line-height: 17px;
                    }
                }
                .c24m-cookie-consent-notice-cnt div,
                .c24m-cookie-consent-screen-cnt div {
                    font-size: 14px;
                    line-height: 20px;
                }
                @media screen and (max-height: 500px) {
                    .c24m-cookie-consent-notice-cnt div,
                    .c24m-cookie-consent-screen-cnt div {
                        font-size: 14px;
                        line-height: 17px;
                    }
                }
                @media screen and (max-height: 350px) {
                    .c24m-cookie-consent-notice-cnt div,
                    .c24m-cookie-consent-screen-cnt div {
                        font-size: 13px;
                        line-height: 15px;
                    }
                }

                .c24m-cookie-consent-notice .c24m-cookie-consent-imprint,
                .c24m-cookie-consent-notice-cnt .c24m-cookie-consent-functional,
                .c24m-cookie-consent-screen-cnt .c24m-cookie-consent-imprint {
                    color: #ffffff;
                    text-decoration: underline;
                    float: right;
                    line-height: 15px;
                    font-size: 12px;
                }
                .c24m-cookie-consent-notice .c24m-cookie-consent-imprint {
                    line-height: 18px;
                }
                .c24m-cookie-consent-notice-cnt .c24m-cookie-consent-functional {
                    max-width: calc(100% - 145px);
                    text-align: right;
                }

                .c24m-cookie-consent-notice-buttons,
                .c24m-cookie-consent-screen-buttons {
                    margin-top: auto;
                    box-sizing: border-box;
                }

                .c24m-cookie-consent-notice-buttons {
                    margin-bottom: 20px;
                }

                .c24m-cookie-consent-screen-buttons {
                    padding-top: 15px;
                }

                a.c24m-cookie-consent-button {
                    text-decoration: none;
                    font-size: 16px;
                    color: #ffffff;
                    padding: 10px 0;
                    float: right;
                    width: calc(50% - 5px);
                    font-weight: normal;
                    border-radius: 5px;
                }

                @media screen and (max-width: 350px) {
                    a.c24m-cookie-consent-button {
                        font-size: 14px;
                    }
                }

                a.c24m-cookie-consent-button-secondary {
                    font-weight: normal;
                    box-sizing: border-box;
                    background-color: transparent;
                    box-shadow: none;
                    border: 1px solid #dcdcdc;
                    float: left;
                    padding: 9px 0;
                }

                .c24m-cookie-consent-screen-list {
                    box-sizing: border-box;
                    max-height: 225px;
                    overflow-y: auto;
                    margin: 0 -15px;
                    border-bottom: 1px solid #ffffff;
                    border-top: 1px solid #ffffff;
                }

                .c24m-cookie-consent-screen-list-entry {
                    padding: 15px;
                    box-sizing: border-box;
                    border-top: 1px solid #ffffff;
                }

                .c24m-cookie-consent-screen-list-entry-header {
                    cursor: pointer;
                    display: flex;
                }

                .c24m-cookie-consent-screen-list-entry:first-child {
                    border-top: none;
                }

                .c24m-cookie-consent-screen-list-entry-header > div:nth-child(1) {
                    padding-right: 10px;
                    box-sizing: border-box;
                }

                .c24m-cookie-consent-screen-list-entry-header > div:nth-child(2) {
                    padding-right: 10px;
                    box-sizing: border-box;
                    flex-grow: 1;
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 700;
                    cursor: pointer;
                }

                .c24m-cookie-consent-screen-list-entry-header > div:nth-child(3) {
                    color: #333333;
                    width: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                }

                .c24m-cookie-consent-screen-list-entry-header input[type='checkbox'] {
                    display: none;
                }

                .c24m-cookie-consent-screen-list-entry-header div:first-child span:before {
                    content: '';
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    background: #ffffff;
                    border: 1px solid #999999;
                    box-sizing: border-box;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                }

                .c24m-cookie-consent-screen-list-entry-header input[type='checkbox']:checked + span:before {
                    background: #ffffff url('https://www.check24.de/assets/images/web/svg/haken-darkblue.svg') no-repeat
                        center;
                    background-size: contain;
                    border: 1px solid #999999;
                    width: 18px;
                    height: 18px;
                }

                .c24m-cookie-consent-screen-list-entry-header input[type='checkbox'][disabled]:checked + span:before {
                    background-color: #b4b4b4;
                    border: 1px solid #999999;
                }

                .c24m-cookie-consent-button-more-icon {
                    display: block;
                    height: 16px;
                    width: 14px;
                }

                .c24m-cookie-consent-button-more-icon-open {
                    transform: rotate(180deg);
                }

                .c24m-cookie-consent-screen-list-entry-content {
                    display: none;
                    box-sizing: border-box;
                    line-height: 18px;
                    padding-top: 10px;
                }
                .c24m-cc-visible .c24m-page {
                    position: fixed;
                }
                .c24m-cc-visible #c24m-page-strict-blocking-layer {
                    display: block;
                }
                .c24m-cc-visible .c24m-cookie-consent-wrapper {
                    display: flex;
                }
                .c24m-cc-visible .c24m-cookie-consent-screen {
                    display: none;
                }

                .c24m-cookie-consent-screen-list-m {
                    padding-left: 15px;
                }

                .c24m-cookie-consent-screen-list-m-title {
                    font-weight: bold;
                    margin: 17px 0 13px;
                }

                .c24m-cookie-consent-screen-list-m-entry {
                    margin-bottom: 15px;
                }

                .c24m-cookie-consent-screen-list-m-entry
                    .c24m-cookie-consent-screen-list-entry-header
                    > div:nth-child(2) {
                    line-height: 19px;
                    font-size: 12px;
                }
                .c24m-cookie-consent-screen-list-m-entry .c24m-cookie-consent-button-more-icon {
                    margin-top: -2px;
                }

                @media print {
                    .c24-cookie-consent-wrapper {
                        display: none;
                    }
                }

                /* Legacy Cookie Layer */
                .c24m-cookie {
                    width: 100%;
                    height: 47px;
                    position: absolute;
                    left: 0;
                    top: -47px;
                    background: #333333;
                }
                .c24m-page.c24m-smb .c24m-cookie {
                    top: -103px;
                }
                .c24m-cookie.c24m-cookie-hide {
                    visibility: hidden;
                }
                .c24m-page.c24m-cookie-transition {
                    -webkit-transition:
                        visibility 0s,
                        top 300ms linear;
                    -o-transition:
                        visibility 0s,
                        top 300ms linear;
                    transition:
                        visibility 0s,
                        top 300ms linear;
                }
                .c24m-page.c24m-cookie-animate {
                    top: 47px;
                    visibility: visible;
                }
                .c24m-page.c24m-smb.c24m-cookie-animate {
                    top: 103px !important;
                }
                .c24m-page.c24m-cookie-animate #c24m-nav-slide {
                    top: -47px;
                }
                .c24m-page.c24m-smb.c24m-cookie-animate #c24m-nav-slide {
                    top: -103px;
                }
                .c24m-cookie .c24m-cookie-cnt {
                    padding: 10px;
                    position: relative;
                }
                .c24m-cookie .c24m-cookie-text {
                    color: #ffffff;
                    font-size: 12px;
                    width: calc(100% - 80px);
                    width: -webkit-calc(100% - 80px);
                    float: left;
                    margin-top: -2px;
                }
                .c24m-cookie .c24m-cookie-text a {
                    text-decoration: underline;
                    color: #1980d0;
                }
                .c24m-cookie .c24m-cookie-button {
                    color: #ffffff;
                    font-size: 13px;
                    display: block;
                    float: right;
                    line-height: 23px;
                    width: 70px;
                    padding: 0;
                    margin-top: 2px;
                }

                a.c24m-cookie-consent-cookielink,
                a.c24m-cookie-consent-cookielink:hover {
                    color: #fff;
                    text-decoration: underline;
                } /* HEADER Customer */
                .c24m-customer {
                    display: block;
                    float: left;
                    width: 38px;
                    height: 40px;
                    padding: 9px 8px;
                    box-sizing: border-box;
                }
                .c24m-customer .c24m-customer-icon {
                    display: block;
                    width: 22px;
                    height: 22px;
                    cursor: pointer;
                    position: relative;
                }
                .c24m-customer-icon.c24m-customer-icon-lo {
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+CiAgICA8cGF0aCBkPSJNMTEsMEM0LjkyNCwwLDAsNC45MjQsMCwxMXM0LjkyNCwxMSwxMSwxMSwxMS00LjkyNCwxMS0xMVMxNy4wNzYsMCwxMSwwWm0wLDIwLjYyNWMtMi4wMywwLTMuOTEyLS42MzUtNS40NjYtMS43MTIsLjE3Ni0yLjExNywxLjkzNC0zLjc4OCw0LjA5MS0zLjc4OGgyLjc1YzIuMTU5LDAsMy45MTYsMS42NzMsNC4wOTEsMy43ODgtMS41NTYsMS4wNzYtMy40MzgsMS43MTItNS40NjYsMS43MTJabTYuNjktMi43MmMtLjYwNi0yLjM4LTIuNzUtNC4xNTUtNS4zMTUtNC4xNTVoLTIuNzVjLTIuNTY3LDAtNC43MDksMS43NzUtNS4zMTUsNC4xNTYtMS44MDYtMS43ODgtMi45MzUtNC4xOTktMi45MzUtNi45MDZDMS4zNzUsNS42OTMsNS42OTMsMS4zNzUsMTEsMS4zNzVzOS42MjUsNC4zMTgsOS42MjUsOS42MjVjMCwyLjcwNy0xLjEzLDUuMTE4LTIuOTM1LDYuOTA1Wk0xMSw1LjVjLTEuODk5LDAtMy40MzcsMS41MzgtMy40MzcsMy40MzhzMS41MzgsMy40MzgsMy40MzcsMy40MzgsMy40MzctMS41MzksMy40MzctMy40MzgtMS41MzgtMy40MzgtMy40MzctMy40MzhabTAsNS41Yy0xLjEzOSwwLTIuMDYyLS45MjQtMi4wNjItMi4wNjJzLjkyNC0yLjA2MiwyLjA2Mi0yLjA2MiwyLjA2MiwuOTI1LDIuMDYyLDIuMDYyLS45MjQsMi4wNjItMi4wNjIsMi4wNjJaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPg==');
                    background-repeat: no-repeat;
                }
                .c24m-customer-icon.c24m-customer-icon-li {
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+CiAgPHBhdGggZD0iTTExLDBDNC45MjQsMCwwLDQuOTI0LDAsMTFzNC45MjQsMTEsMTEsMTEsMTEtNC45MjQsMTEtMTFTMTcuMDc2LDAsMTEsMFptNi42OSwxNy45MDVjLS42MDYtMi4zOC0yLjc1LTQuMTU1LTUuMzE1LTQuMTU1aC0yLjc1Yy0yLjU2NSwwLTQuNzA5LDEuNzc1LTUuMzE1LDQuMTU1LTEuODA1LTEuNzg3LTIuOTM1LTQuMTk4LTIuOTM1LTYuOTA1QzEuMzc1LDUuNjkzLDUuNjkzLDEuMzc1LDExLDEuMzc1czkuNjI1LDQuMzE4LDkuNjI1LDkuNjI1YzAsMi43MDctMS4xMyw1LjExOC0yLjkzNSw2LjkwNVoiIGZpbGw9IiNmZmYiLz4KICA8Y2lyY2xlIGN4PSIxMSIgY3k9IjguOTM3IiByPSIzLjQzOCIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4=');
                    background-repeat: no-repeat;
                }
                .c24m-customer-icon svg {
                    position: relative;
                } /* HEADER Navi */
                .c24m-header-top-icons-left nav {
                    float: left;
                }
                .c24m-nav-button {
                    height: 40px;
                    width: 42px;
                    float: left;
                    cursor: pointer;
                    z-index: 101;
                    padding: 9px 8px;
                    box-sizing: border-box;
                }
                .c24m-nav-button-wrapper,
                .c24m-nav-burger {
                    width: 26px;
                    height: 22px;
                    box-sizing: border-box;
                }
                .c24m-nav-button-wrapper #c24m-nav-button-notification {
                    height: 16px;
                    min-width: 16px;
                    line-height: 16px;
                    -webkit-border-radius: 8px;
                    -moz-border-radius: 8px;
                    border-radius: 8px;
                    background: #e30613;
                    color: #ffffff;
                    font-size: 12px;
                    text-align: center;
                    position: absolute;
                    top: 3px;
                    right: 5px;
                    font-weight: bold;
                    display: none;
                }
                #c24m-nav-slide {
                    position: absolute;
                    top: 0;
                    left: -100%;
                    z-index: 9;
                    width: 100%;
                    height: 100%;
                    padding: 0 0 10px;
                    box-sizing: border-box;
                    background: #f4f4f4;
                    color: #666666;
                    overflow-x: scroll;
                    display: none;
                    overscroll-behavior-y: contain;
                }
                .c24m-nav-slide-content {
                    width: 100%;
                    overflow-x: hidden;
                }
                #c24m-nav-slide ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                .c24m-navi {
                    width: 100%;
                    height: 100%;
                    border: 0;
                }
                .c24m-navi .c24m-navi-header {
                    width: 100%;
                }
                .c24m-navi .c24m-navi-header {
                    height: 44px;
                    width: 100%;
                    position: relative;
                    cursor: pointer;
                }
                .c24m-navi .c24m-navi-header .c24m-navi-header-close {
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    right: 10px;
                    top: 14px;
                }
                .c24m-navi .c24m-navi-header-bottom {
                    width: 100%;
                    position: relative;
                    background: #ffffff;
                }
                .c24m-navi .c24m-navi-header-bottom span,
                .c24m-navi .c24m-navi-header-bottom a {
                    display: block;
                    line-height: 44px;
                    font-size: 16px;
                    font-weight: normal;
                    text-decoration: none;
                    color: #333;
                    padding-left: 10px;
                    margin: 0;
                    position: relative;
                }
                .c24m-navi .c24m-navi-header a {
                    display: block;
                    line-height: 44px;
                    font-size: 16px;
                    font-weight: normal;
                    text-decoration: none;
                    color: #005ea8;
                    padding-left: 10px;
                }
                .c24m-navi .c24m-navi-header span {
                    display: inline-block;
                    line-height: 44px;
                    font-size: 16px;
                    float: left;
                    padding-left: 10px;
                }
                .c24m-navi .c24m-navi-header .c24m-navi-header-top-svg {
                    display: inline-block;
                    float: left;
                    height: 22px;
                    width: 15px;
                    margin: 5px 10px 0 0;
                }
                .c24m-navi .c24m-navi-section {
                    width: 100%;
                    padding: 0;
                    margin-top: 10px;
                    background: #ffffff;
                }
                .c24m-navi .c24m-navi-section.c24m-navi-section-logout {
                    background: #f4f4f4;
                }
                .c24m-navi .c24m-navi-section.c24m-navi-section-top {
                    margin-top: 0;
                }
                .c24m-navi .c24m-navi-section ul {
                    padding: 0;
                    margin: 0;
                    list-style: none;
                }
                #c24m-nav-slide .c24m-navi .c24m-nav-comparisons .c24m-nav-comp-item ul {
                    margin-bottom: 10px;
                }
                .c24m-navi .c24m-navi-section ul li {
                    display: block;
                    width: 100%;
                    height: 44px;
                }
                .c24m-navi .c24m-navi-section ul li > a,
                .c24m-navi .c24m-navi-section ul li > span {
                    display: block;
                    height: 44px;
                    padding-left: 54px;
                    font-weight: normal;
                    text-decoration: none;
                    position: relative;
                    color: #333;
                }
                .c24m-navi .c24m-navi-section ul li a span.c24m-navi-svg,
                .c24m-navi .c24m-navi-section ul li span span.c24m-navi-svg,
                .c24m-navi .c24m-nav-comp-item ul li a span.c24m-navi-svg {
                    width: 32px;
                    text-align: center;
                    position: absolute;
                    top: 0;
                    left: 10px;
                }
                .c24m-navi .c24m-navi-section ul li a span.c24m-navi-svg svg,
                .c24m-navi .c24m-navi-section ul li span span.c24m-navi-svg svg,
                .c24m-navi .c24m-nav-comp-item ul li a span.c24m-navi-svg svg {
                    fill: #666666;
                    height: 32px;
                    width: 32px;
                    margin-top: 5px;
                }
                .c24m-navi .c24m-navi-section ul li.c24m-kb-logout-navi span.c24m-navi-svg svg {
                    fill: #005ea8;
                }
                .c24m-navi .c24m-navi-section ul li span.c24m-navi-element {
                    line-height: 44px;
                    font-size: 16px;
                    color: #333;
                    display: block;
                    border-bottom: 1px solid #dcdcdc;
                    position: relative;
                }
                .c24m-navi .c24m-navi-section ul li.c24m-kb-logout-navi span.c24m-navi-element {
                    color: #005ea8;
                }
                .c24m-navi .c24m-navi-section ul li:last-child span.c24m-navi-element,
                .c24m-navi .c24m-nav-comp-item ul li:last-child span.c24m-navi-element {
                    border-bottom: 0;
                }
                .c24m-navi .c24m-navi-section ul li span.c24m-navi-element.c24m-navi-element-plain {
                    margin-left: 38px;
                }
                .c24m-navi .c24m-navi-section ul li span.c24m-navi-element-count {
                    line-height: 20px;
                    margin-top: 12px;
                    font-size: 14px;
                    color: #999999;
                    float: right;
                    margin-right: 17px;
                    text-align: right;
                    display: none;
                }

                #c24m-nav-slide .c24-nav-content-wrapper {
                    position: relative;
                    width: 100%;
                    transition: left 0.2s;
                    -webkit-transition: left 0.2s;
                    -moz-transition: left 0.2s;
                    left: 0;
                }
                #c24m-nav-slide.c24m-comp-open .c24-nav-content-wrapper {
                    left: -100%;
                }
                #c24m-nav-slide .c24m-nav-comparisons {
                    position: absolute;
                    top: 0;
                    left: 100%;
                    width: 100%;
                    max-height: 100%;
                    overflow: hidden;
                }
                #c24m-nav-slide.c24m-comp-open .c24-nav-content-wrapper .c24m-nav-comparisons {
                    max-height: unset;
                    z-index: 200;
                }
                #c24m-nav-slide.c24m-comp-open .c24m-nav-slide-content {
                    overflow-x: visible;
                }
                #c24m-nav-slide .c24m-nav-comparisons .c24m-nav-comp-back {
                    background: #ffffff;
                    font-size: 16px;
                    line-height: 18px;
                    padding: 13px 0 13px 35px;
                    color: #333333;
                    position: relative;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul {
                    padding: 0;
                    margin: 0;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li {
                    background: #ffffff;
                    font-size: 16px;
                    line-height: 20px;
                    color: #333333;
                    display: block;
                    position: relative;
                }
                #c24m-nav-slide
                    .c24m-nav-comparisons
                    ul
                    li
                    span:not(.c24-nav-ele-new-wrapper):not(.c24-nav-ele-new):not(.c24m-navi-svg):not(
                        .c24m-navi-element
                    ) {
                    display: block;
                    padding: 18px 10px 12px 10px;
                    background: #f4f4f4;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li span a {
                    color: #333;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul li {
                    background: #fff;
                    padding-left: 10px;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul.c24m-nav-comp-item-sub li {
                    padding-left: 0;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul li ul {
                    padding-left: 10px;
                }
                #c24m-nav-slide .c24m-nav-comparisons .c24m-nav-comp-item-sub {
                    padding-left: 10px;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul li ul li {
                    padding-left: 0;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul:not(.c24m-nav-comp-item-sub) {
                    padding-left: 10px;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul li a {
                    color: #333333;
                    text-decoration: none;
                    border-bottom: 1px solid #dcdcdc;
                    padding: 12px 0;
                    display: block;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul li.c24m-nav-subline a {
                    padding: 4px 0;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul li a:before,
                #c24m-nav-slide .c24m-nav-comparisons .c24m-nav-comp-back:before,
                .c24m-navi .c24m-navi-section ul li a span.c24m-navi-element:not(.c24m-navi-logout):before,
                .c24m-navi .c24m-nav-comp-item ul li a span.c24m-navi-element:not(.c24m-navi-logout):before,
                .c24m-navi .c24m-navi-section ul li span span.c24m-navi-element:not(.c24m-navi-logout):before,
                .c24m-navi .c24m-navi-header-bottom :not(#c24m-kb-login-navi) span:before,
                .c24m-navi .c24m-navi-header-bottom a:before {
                    content: '';
                    height: 13px;
                    width: 7px;
                    background-size: 100%;
                    position: absolute;
                    top: calc(50% - 7px);
                    right: 15px;
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA3LjcgMTMuNyIgPg0KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSwgMSkiPg0KCTxwb2x5Z29uIGZpbGw9IiNCNEI0QjQiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgcG9pbnRzPSI0LjYsNS45IC0xLDExLjYgMC4xLDEyLjcgNi43LDUuOSANCgkJMC4xLC0xIC0xLDAuMSIvPg0KPC9nPg0KPC9zdmc+DQo=');
                    background-repeat: no-repeat;
                }
                #c24m-nav-slide .c24m-nav-comparisons .c24m-nav-comp-back:before {
                    right: unset;
                    left: 15px;
                    transform: rotate(180deg);
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul:not(.c24m-nav-comp-item-sub) li:last-child a {
                    border-bottom: 0;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li ul.c24m-nav-comp-item-sub li:last-child ul li:last-child a {
                    border-bottom: 0;
                }
                #c24m-nav-slide .c24m-nav-comparisons .c24m-nav-comp-subject {
                    font-size: 14px;
                    color: #999999;
                    line-height: 16px;
                    padding-top: 15px;
                    padding-bottom: 5px;
                    padding-left: 0;
                    border-bottom: 1px solid #dcdcdc;
                }
                .c24m-navi .c24m-navi-section ul li a.c24m-kb-logout-navi span.c24m-navi-logout {
                    border: 0;
                }
                #c24m-nav-slide .c24m-nav-comparisons ul li span.c24m-nav-subline-gold {
                    color: #b39656;
                    font-size: 12px;
                    padding: 0;
                    background: #fff;
                    line-height: 16px;
                }

                .c24m-nav-comp-item li a .c24-nav-ele-new-wrapper {
                    position: relative;
                }

                .c24-nav-ele-new {
                    background-color: #e30613;
                    color: #fff;
                    font-size: 12px;
                    padding: 3px 6px;
                    border-radius: 2px;
                    line-height: 11px;
                    position: absolute;
                    top: 0;
                    right: -44px;
                } /* Smart App Banner */
                .c24m-sab.c24m-sab-v2 {
                    display: block;
                    cursor: pointer;
                    background: #ffffff;
                    color: #333333;
                    min-height: 60px;
                    z-index: 101;
                }

                .c24m-sab.c24m-sab-rsn {
                    background: #ecf7fd;
                }

                .c24m-sab.c24m-sab-hide {
                    display: none;
                }

                .c24m-sab.c24m-sab-v2 svg {
                    fill: #b3b3b3;
                }

                .c24m-sab .c24m-sab-close {
                    display: block;
                    cursor: pointer;
                    width: 12px;
                    height: 12px;
                    padding: 24px 10px;
                    line-height: 14px;
                    float: left;
                }

                .c24m-sab .c24m-sab-close svg {
                    width: 12px;
                    height: 12px;
                }

                .c24m-sab.c24m-sab-v2 .c24m-sab-logo {
                    display: block;
                    float: left;
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    margin: 10px 0 0;
                }

                .c24m-sab .c24m-sab-text {
                    cursor: pointer;
                    display: inline-block;
                    float: left;
                    padding: 10px 0 10px 10px;
                    width: calc(100% - 115px);
                }

                .c24m-sab.c24m-sab-v2 .c24m-sab-text {
                    width: initial;
                }

                .c24m-sab .c24m-sab-arrow {
                    display: block;
                    cursor: pointer;
                    width: 9px;
                    height: 14px;
                    line-height: 14px;
                    padding: 21px 10px;
                    float: right;
                }

                .c24m-sab.c24m-sab-v2 .c24m-sab-arrow {
                    display: none;
                }

                .c24m-page.c24m-cookie-animate.c24m-sab-visible #c24m-nav-slide {
                    top: -103px;
                }

                .c24m-page.c24m-sab-visible:not(.c24m-cookie-animate) #c24m-nav-slide {
                    top: -60px;
                }

                .c24m-hidden-content {
                    display: none;
                }

                .c24m-sab.c24m-sab-v2 button {
                    display: block;
                    float: right;
                    margin-right: 10px;
                    text-decoration: none;
                    font-family: Arial, Helvetica, sans-serif;
                    font-weight: normal;
                    cursor: pointer;
                    border: 0;
                    background-color: #0563c1;
                    -moz-border-radius: 3px;
                    -webkit-border-radius: 3px;
                    border-radius: 3px;
                    vertical-align: middle;
                    color: #ffffff;
                    font-size: 14px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    width: 102px;
                    margin-top: 10px;
                }

                .c24m-sab.c24m-sab-v2 button:hover,
                .c24m-sab.c24m-sab-v2 button:active {
                    background-color: #015fa4;
                }

                @media only screen and (max-width: 300px) {
                    .c24m-sab.c24m-sab-v2 button {
                        width: 24%;
                    }
                }

                @media only screen and (max-width: 260px) {
                    .c24m-sab.c24m-sab-v2 button {
                        font-size: 12px;
                    }
                }

                .c24m-sab .c24m-sab-title {
                    display: block;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: normal;
                    margin: 2px 0 3px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .c24m-sab-stars {
                    display: block;
                    float: left;
                    margin: 2px 4px 3px 0;
                }

                .c24m-sab-stars svg {
                    width: 11px;
                    float: left;
                    margin-right: 1px;
                }

                .c24m-sab-stars svg polygon {
                    fill: #ffca04;
                }

                .c24m-sab-stars svg g polygon {
                    fill: #dcdcdc;
                }

                .c24m-sab-review-count {
                    display: inline-block;
                    float: left;
                    line-height: 14px;
                    font-size: 12px;
                    color: #666;
                } /* HEADER Search */
                #c24m-search {
                    height: 30px;
                    padding: 0 0 5px;
                }
                .c24m-search-content {
                    position: relative;
                }
                .c24m-search-button {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 18px;
                    height: 21px;
                    padding: 4px 4px 5px 10px;
                    z-index: 110;
                    -webkit-appearance: none;
                }

                .c24m-search-button svg {
                    height: 21px;
                    width: 18px;
                }
                .c24m-search-entry::-webkit-scrollbar {
                    display: none;
                }
                #c24m-body .ui-widget {
                    font-family: Arial, Verdana, sans-serif;
                }

                #c24m-body .c24m-search-ac {
                    left: 0 !important;
                    width: 100% !important;
                    border: 0;
                }
                #c24m-search input {
                    height: 30px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 110;
                    border: none;
                    font-size: 15px;
                    line-height: 20px;
                    -webkit-appearance: none;
                    width: 100%;
                    padding: 5px 32px;
                }

                #c24m-search input::placeholder {
                    color: #999;
                    opacity: 1;
                }
                #c24m-search input::-webkit-input-placeholder {
                    color: #999;
                    opacity: 1;
                }
                #c24m-search input::-moz-placeholder {
                    color: #999;
                    opacity: 1;
                }
                #c24m-search input:-ms-input-placeholder {
                    color: #999;
                }
                #c24m-search input:-moz-placeholder {
                    color: #999;
                    opacity: 1;
                }

                #c24-search-header::-webkit-input-placeholder {
                    /* Chrome */
                    color: #999999;
                    background-color: #ffffff;
                }
                #c24-search-header:-ms-input-placeholder {
                    /* IE 10+ */
                    color: #999999;
                    background-color: #ffffff;
                }
                #c24-search-header::-moz-placeholder {
                    /* Firefox 19+ */
                    color: #999999;
                    background-color: initial;
                    opacity: 1;
                }
                #c24-search-header:-moz-placeholder {
                    /* Firefox 4 - 18 */
                    color: #999999;
                    background-color: initial;
                    opacity: 1;
                }

                #c24m-searchcontainer {
                    width: 100%;
                    height: 30px;
                    position: relative;
                    -webkit-border-radius: 15px;
                    -moz-border-radius: 15px;
                    border-radius: 15px;
                    overflow: hidden;
                }

                #c24m-searchcontainer input:focus {
                    border: 1px solid #ffbb1c;
                    border-radius: 15px;
                    padding-left: 31px;
                }

                /* #c24m-takeOver-Arrow {
    height: 11px;
    width: 11px;
    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIxMDAuMXB4IiBoZWlnaHQ9IjEwMHB4IiB2aWV3Qm94PSIwIDAgMTAwLjEgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAuMSAxMDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojQjRCNEI0O30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTk3LjksODdsLTcxLTcxLjFsNTIuNSwxYzIuMSwwLDQtMC43LDUuNS0yLjJjMS41LTEuNCwyLjMtMy4yLDIuMy01LjRjMC4xLTIuMi0wLjctNC4xLTIuMi01LjcKCWMtMS40LTEuNC0zLjEtMi4xLTUuMi0yLjJMNy44LDBDNS42LTAuMSwzLjcsMC42LDIuMiwyLjJTLTAuMSw1LjYsMCw3LjhsMS4yLDcxLjhjMC4yLDIuMiwxLDQsMi41LDUuNWMxLjUsMS40LDMuMywyLjEsNS41LDIKCWMyLjEtMC4xLDQtMC45LDUuNC0yLjRjMS41LTEuNSwyLjItMy4zLDIuMS01LjZsLTEtNTIuNmw3MS4xLDcxLjNjMS42LDEuNiwzLjUsMi4zLDUuOCwyLjNjMi4zLDAsNC4xLTAuOSw1LjYtMi41CgljMS4zLTEuNSwxLjktMy4zLDEuOS01LjNDMTAwLDkwLjIsOTkuMyw4OC40LDk3LjksODd6Ii8+Cjwvc3ZnPgo=') no-repeat center center ;
    -webkit-background-size: 11px 11px;
    background-size: 11px 11px;
    position: absolute;
    top: 50%;
    margin-top: -11px;
    right: 0;
} */

                #c24m-body .ui-widget-content {
                    border: none;
                }
                /* #c24m-body .ui-menu-item {
    border-bottom:1px solid #dcdcdc !important;
    position:relative;
    margin:0; padding:0;
    height: 44px;
    display: table;
    width: 100%;
} */

                /* #c24m-body .ui-menu-item:last-child {
    border-bottom:0;
} */

                /* #c24m-body .ui-menu .ui-menu-divider {
    margin: 0;
} */

                /* #c24m-body .ui-menu-item a {
    padding: 6px 10px 6px 10px;
    text-decoration: none;
    color: #333333;
    font-size: 16px;
    line-height: 20px;
    display: table-cell;
    vertical-align: middle;
} */

                /* #c24m-search-cat {
    font-size: 11px;
    font-family: Arial, sans-serif;
    color: #999999;
    line-height: 13px;
    display: block;
} */

                /* #c24m-body .ui-menu-item a.c24m-phrase-link {
    z-index: 1000;
    width: 85%;
} */

                #c24m-search .c24m-search-clear {
                    position: absolute;
                    top: 8px;
                    right: 10px;
                    border: 0;
                    width: 14px;
                    height: 14px;
                    z-index: 111;
                    display: none;
                }

                /* #c24m-search .ui-input-text {
    text-shadow: none !important;
} */
                /* #c24m-search .ui-corner-all {
    -webkit-border-radius: 0 !important;
    -moz-border-radius: 0 !important;
    border-radius: 0 !important;
    box-sizing:border-box;
    border:0 !important;
} */
                /* #c24m-search .ui-shadow-inset {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    text-shadow: none !important;
} */
                .c24m-search-icon-wrapper {
                    width: 36px;
                    height: 40px;
                    box-sizing: border-box;
                    padding: 9px 8px;
                    float: right;
                    position: relative;
                }
                .c24m-search-icon {
                    width: 20px;
                    height: 23px;
                    background: transparent
                        url('data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgODcuMSAxMDAiPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik02NC44LDE0LjFDNTIuNi0xLjcsMjkuOS00LjYsMTQuMSw3LjVTLTQuNiw0Mi40LDcuNSw1OC4yYzExLDE0LjIsMzAuMywxNy45LDQ1LjYsOS45TDc3LDk5DQoJYzAuOSwxLjIsMi42LDEuNCwzLjYsMC41bDUuNS00LjJjMS4yLTAuOSwxLjQtMi42LDAuNS0zLjZMNjIuOCw2MC44Qzc0LjUsNDgsNzUuOCwyOC4yLDY0LjgsMTQuMXogTTUyLjksNTcuOA0KCWMtMTEuOSw5LjItMjkuMSw3LTM4LjMtNWMtOS4zLTExLjktNy0yOS4xLDUtMzguM2MxMS45LTkuMywyOS4xLTcsMzguMyw1QzY3LjEsMzEuNCw2NC44LDQ4LjUsNTIuOSw1Ny44eiIvPg0KPC9zdmc+')
                        top center no-repeat;
                }
                .c24m-search-slim #c24-header-bottom {
                    display: none;
                }
                .c24m-search-slim.c24m-search-open #c24-header-bottom {
                    display: block;
                }

                .hits-search-element {
                    border-radius: 0;
                }

                .hits-suggest {
                    font-family: Arial, sans-serif;
                    border: 1px solid #eeeeee;
                    background: #fff;
                    z-index: 10013;
                    position: absolute;
                    width: 100%;
                }

                .hits-suggest a {
                    color: #333333;
                }

                .hits-suggest a:hover,
                .hits-suggest a:focus,
                .hits-suggest a:active {
                    text-decoration: none;
                }

                .hits-suggest ul {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }

                .hits-suggest ul li.hits-suggest-item {
                    font-size: 14px;
                    line-height: 20px;
                    margin: 0;
                    padding: 11px 10px 2px 15px;
                    border-radius: 0;
                    list-style-position: inside;
                    border-bottom: 1px solid #dcdcdc !important;
                    position: relative;
                    max-height: 60px;
                    overflow: hidden;
                }

                .hits-suggest ul li.hits-suggest-item div {
                    display: inline-block;
                    min-height: 28px;
                    width: 100%;
                }

                .hits-suggest ul:last-child {
                    border: none;
                }

                .hits-suggest ul li.hits-suggest-item-active {
                    cursor: pointer;
                }

                .hits-suggest hr {
                    margin: 0;
                    border: none;
                }

                .hits-suggest .hits-suggest-directlink {
                    color: #333333;
                    font-weight: normal;
                }

                .hits-suggest-directlink-subtitle {
                    color: #0563c1;
                }

                .hits-suggest .hits-suggest-category {
                    color: #999999;
                    font-size: 12px;
                }

                .hits-suggest ul li.hits-suggest-item.hits-suggest-cat {
                    line-height: 16px;
                }

                .hits-takeover-arrow {
                    height: 14px;
                    width: 14px;
                    background: url('https://search.check24.de/suche/img/takeover-arrow.svg') no-repeat center center;
                    -webkit-background-size: 14px 14px;
                    background-size: 14px 14px;
                    position: absolute;
                    right: 0;
                    top: 0;
                    float: right;
                    display: block;
                    padding: 16px;
                }

                .hits-suggest-phraselink {
                    float: left;
                    padding-right: 20px;
                }

                /* .hits-no-scroll {
    height:100%;
    overflow:hidden;
} */ /* ULI loginlayer */
                .c24-uli-loginlayer {
                    display: none;
                    border: 0;
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 20001;
                    background: #f4f4f4;
                    min-height: 100%;
                }
                .c24-uli-loginlayer-iframe {
                    width: 100%;
                    border: none;
                    -moz-user-select: none;
                    -webkit-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                    -o-user-select: none;
                    z-index: 20002;
                    background: #f4f4f4;
                }
                .c24-uli-loginlayer-close {
                    width: 11px;
                    height: 22px;
                    padding: 9px 12px 9px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: url('data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTguMiAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPiA8cG9seWdvbiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjE2LjQsNTAgNTguMiw4LjIgNTAsMCAwLDUwIDUwLDEwMCA1OC4yLDkxLjggIj48L3BvbHlnb24+IDwvc3ZnPg==')
                        no-repeat;
                    background-size: 12px;
                    background-position: 15px;
                    cursor: pointer;
                    z-index: 20003;
                }
                .c24-uli-loginlayer-header {
                    width: 100%;
                    height: 40px;
                    background: #022d94;
                    margin-bottom: 10px;
                }
                .c24-uli-loginlayer-header-logo {
                    display: block;
                    width: 100px;
                    height: 26px;
                    position: absolute;
                    top: 9px;
                    left: 50%;
                    margin-left: -50px;
                }
                .c24m-contact-layer-chatbot {
                    padding: 10px 15px;
                }
                .c24m-contact-layer-chatbot .c24m-contact-layer-content {
                    padding: 0;
                }
                .c24m-contact-layer-chatbot .c24m-contact-title {
                    font-size: 15px;
                    color: #333;
                    text-align: center;
                    margin: 5px 0 45px;
                    font-weight: bold;
                }
                .c24m-contact-layer-chatbot .c24m-contact-text-wrapper {
                    background: #f7f7f7;
                    border-radius: 17px;
                    padding: 40px 20px 14px;
                    font-size: 14px;
                    line-height: 18px;
                    color: #333333;
                    position: relative;
                    cursor: pointer;
                }
                .c24m-contact-layer-chatbot .c24m-contact-text {
                    white-space: normal;
                }
                .c24m-contact-layer-chatbot .c24m-contact-img {
                    height: 56px;
                    width: 56px;
                    border-radius: 28px;
                    position: absolute;
                    left: calc(50% - 30px);
                    top: -30px;
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NTAuMTc2IDU1MC4xNzYiPgogIDxjaXJjbGUgY3g9IjI3NS4wODgiIGN5PSIyNzUuMDg4IiByPSIyNzUuMDg4IiBmaWxsPSIjZDNlY2ViIiAvPgogIDxnPgogICAgPHBhdGggZD0iTTMzMC4xNSwxOTguMzcxbDIwLjMwNCw2OC40OTJjNS42NTgsMTkuMDg4LDIwLjU4OSwzNC4wMTgsMzkuNjc3LDM5LjY3N2w2OC40OTIsMjAuMzA0YzcuMTg3LDIuMTMxLDcuMTg3LDEyLjMwOSwwLDE0LjQzOWwtNjguNDkyLDIwLjMwNGMtMTkuMDg4LDUuNjU4LTM0LjAxOCwyMC41ODktMzkuNjc3LDM5LjY3N2wtMjAuMzA0LDY4LjQ5MmMtMi4xMzEsNy4xODctMTIuMzA5LDcuMTg3LTE0LjQzOSwwbC0yMC4zMDQtNjguNDkyYy01LjY1OC0xOS4wODgtMjAuNTg5LTM0LjAxOC0zOS42NzctMzkuNjc3bC02OC40OTEtMjAuMzA0Yy03LjE4Ny0yLjEzMS03LjE4Ny0xMi4zMDksMC0xNC40MzlsNjguNDkyLTIwLjMwNGMxOS4wODgtNS42NTgsMzQuMDE4LTIwLjU4OSwzOS42NzctMzkuNjc3bDIwLjMwMy02OC40OTFjMi4xMzEtNy4xODcsMTIuMzA5LTcuMTg3LDE0LjQzOSwwaDBaIiBmaWxsPSIjMDA1YzYxIiBzdHJva2Utd2lkdGg9IjAiLz4KICAgIDxwYXRoIGQ9Ik0xODIuNTY4LDg0LjE2OWwxMS44MywzOS45MDZjMy4yOTcsMTEuMTIyLDExLjk5NiwxOS44MiwyMy4xMTcsMjMuMTE3bDM5LjkwNiwxMS44M2M0LjE4NywxLjI0MSw0LjE4Nyw3LjE3MiwwLDguNDEzbC0zOS45MDYsMTEuODNjLTExLjEyMiwzLjI5Ny0xOS44MiwxMS45OTYtMjMuMTE3LDIzLjExN2wtMTEuODMsMzkuOTA2Yy0xLjI0MSw0LjE4Ny03LjE3Miw0LjE4Ny04LjQxMywwbC0xMS44My0zOS45MDZjLTMuMjk3LTExLjEyMi0xMS45OTYtMTkuODItMjMuMTE3LTIzLjExN2wtMzkuOTA2LTExLjgzYy00LjE4Ny0xLjI0MS00LjE4Ny03LjE3MiwwLTguNDEzbDM5LjkwNi0xMS44M2MxMS4xMjItMy4yOTcsMTkuODItMTEuOTk2LDIzLjExNy0yMy4xMTdsMTEuODMtMzkuOTA2YzEuMjQxLTQuMTg3LDcuMTcyLTQuMTg3LDguNDEzLDBaIiBmaWxsPSIjMDA1YzYxIiBzdHJva2Utd2lkdGg9IjAiLz4KICA8L2c+Cjwvc3ZnPg==');
                    background-size: 100%;
                }
                .c24m-contact-layer-chatbot .c24m-chatbot-open {
                    color: #0563c1;
                    text-align: right;
                    margin-top: 5px;
                }
                .c24m-contact-layer-chatbot a.c24m-contact-layer-link {
                    display: block;
                    margin: 15px 0 5px;
                    font-size: 14px;
                    text-align: center;
                    color: #333;
                }
                .c24m-contact-layer-chatbot a.c24m-contact-layer-link span {
                    color: #0563c1;
                }
                .c24m-tap-bar {
                    background: rgba(250, 250, 250, 0.95);
                    width: 100%;
                    display: flex;
                    gap: 4px;
                    padding: 6px 8px;
                    place-content: center;
                    box-sizing: border-box;
                    position: fixed;
                    z-index: 110;
                    bottom: 0;
                    border-top: 1px solid #dcdcdc;
                    backdrop-filter: blur(3px);
                    -webkit-backdrop-filter: blur(3px);
                }
                body:not(.c24-app-context) .c24m-tap-bar {
                    padding-bottom: max(env(safe-area-inset-bottom, 8px), 8px);
                }
                body.c24-app-context .c24m-tap-bar {
                    display: none !important;
                }
                .c24m-tap-bar-option {
                    width: 25%;
                    text-align: center;
                }
                .c24m-tap-bar-icon {
                    height: 28px;
                    width: 30px;
                    margin: 0 auto 4px auto;
                }
                .c24m-tap-bar-option:not(.c24m-tap-bar-option-chat) .c24m-tap-bar-icon svg {
                    fill: #b4b4b4;
                }
                .c24m-tap-bar-text {
                    color: #b4b4b4;
                }
                .c24m-tap-bar-option.active:not(.c24m-tap-bar-option-chat) .c24m-tap-bar-icon svg {
                    fill: #0563c1;
                }
                .c24m-tap-bar-option.active .c24m-tap-bar-text {
                    color: #0563c1;
                }

                #Chatbot-wrapper {
                    z-index: var(--z-index-wireframeChatty) !important;
                }
                #Chatbot-wrapper .ActivityAnswerMessage__content-box * {
                    box-sizing: unset;
                }
                #Chatbot-wrapper .button {
                    font-family: unset;
                    padding: unset;
                    width: unset;
                }
                .c24-uli-loginlayer {
                    z-index: var(--z-index-wireframeUliLoginLayer);
                }
                .ScrollArrow_button {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .c24-uli-loginlayer-close {
                    padding-top: 31px;
                    padding-right: 31px;
                    background-size: 11px;
                    left: 4px;
                }
            `}</style>
        </>
    );
}
